import { type StyledComponent } from '@emotion/styled'
import { Box, type BoxProps, Popper as MuiPopper, type PopperProps, styled, type Theme } from '@mui/material'
import { guidedTourClasses } from './classes.js'
import { zIndexGuidedTour } from './zIndex.js'

export const Arrow: StyledComponent<BoxProps> = styled(Box)({
  position: 'absolute',
  width: 0,
  height: 0,
  zIndex: zIndexGuidedTour.arrow,
  borderWidth: 10,
  borderStyle: 'solid',
  borderColor: 'transparent',
})

const getBorderColor = (theme: Theme) =>
  theme.palette.mode === 'dark' ? 'rgb(49, 49, 49)' : theme.palette.common.white

export const Popper: StyledComponent<PopperProps> = styled(MuiPopper)(({ theme }) => ({
  zIndex: zIndexGuidedTour.popper,
  '& > div': {
    position: 'relative',
  },
  '&[data-popper-placement*="bottom"]': {
    '& > div': {
      marginTop: 2,
    },
    [`& .${guidedTourClasses.arrow}`]: {
      top: 0,
      left: 0,
      marginTop: -9,
      borderTopWidth: 0,
      borderBottomColor: getBorderColor(theme),
    },
  },
  '&[data-popper-placement*="top"]': {
    '& > div': {
      marginBottom: 2,
    },
    [`& .${guidedTourClasses.arrow}`]: {
      bottom: 0,
      left: 0,
      marginBottom: -9,
      borderBottomWidth: 0,
      borderTopColor: getBorderColor(theme),
    },
  },
  '&[data-popper-placement*="right"]': {
    '& > div': {
      marginLeft: 2,
    },
    [`& .${guidedTourClasses.arrow}`]: {
      left: 0,
      marginLeft: -9,
      borderLeftWidth: 0,
      borderRightColor: getBorderColor(theme),
    },
  },
  '&[data-popper-placement*="left"]': {
    '& > div': {
      marginRight: 2,
    },
    [`& .${guidedTourClasses.arrow}`]: {
      right: 0,
      marginRight: -9,
      borderRightWidth: 0,
      borderLeftColor: getBorderColor(theme),
    },
  },
}))
